<template>
    <div class="from-to-box-wrapper">
        <div class="from-to-box  from-to-box-double" style="margin-right: 5px;">
            <v-input
                    v-model="selectedFromValue"
                    v-validate="'max:100'"
                    :error-messages="errors.collect('fromValue')"
                    data-vv-name="toValue"
                    data-vv-as="toValue"
            >
                <input v-model="selectedFromValue" type="text" placeholder="FROM"  @blur="onBlur"/>
            </v-input>
        </div>

        <div class="from-to-box">
            <v-input
                    v-model="selectedToValue"
                    v-validate="'max:100'"
                    :error-messages="errors.collect('toValue')"
                    data-vv-name="toValue"
                    data-vv-as="toValue"
            >
                <input v-model="selectedToValue" type="text" placeholder="TO"  @blur="onBlur" />
            </v-input>

        </div>

    </div>
</template>

<script>

    export default {
        props: {
            startingValues: {},
            isBreakApart: null,
        },

        data() {
            return {
                selectedFromValue: (this.startingValues[0]) ? this.startingValues[0] : '5',
                selectedToValue: (this.startingValues[1]) ? this.startingValues[1] : '',
            };
        },
        created() {
            this.update();
        },
        methods: {
            update() {
                if (this.isBreakApart) {
                    this.selectedFromValue = '';
                    this.selectedToValue = '';
                }
                this.$emit('input', this.selectedFromValue + ',' + this.selectedToValue);
            },
            validate(){
                this.selectedFromValue = isNaN(parseFloat(this.selectedFromValue))? '': parseFloat(this.selectedFromValue);
                this.selectedToValue = isNaN(parseFloat(this.selectedToValue))? '': parseFloat(this.selectedToValue);


            },
            onBlur(){
                if( this.selectedToValue!=='' && this.selectedToValue < this.selectedFromValue){
                    this.selectedToValue= this.selectedFromValue + 5;
                }
                this.validate();
                this.update();
            }



        },
    };

</script>

<style lang="scss">
    @import '../../style/common/RevenueFromToBox.scss';
</style>
